import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { authorPillars, images } from "../../data/content";
export function AuthorSection() {
  return <section className="bg-ink px-5 py-16 sm:py-24" aria-labelledby="author-title" data-id="element-70" data-mp="3qygy5rhtfh4j">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[360px_1fr] md:items-start" data-id="element-71" data-mp="3vy3kqrjja9q0">
        <img src={images.author} alt="Dr. Michael Carter in his clinic" className="w-full rounded-3xl object-cover aspect-[4/5] md:sticky md:top-8" loading="lazy" data-id="element-72" data-mp="2yacrb2nicy09" />
        <div className="space-y-4 text-[17px] leading-relaxed text-white/80" data-id="element-73" data-mp="388sh92asu186">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.18em] text-gold" data-id="element-74" data-mp="38avhef5o1aqm">About the author</p>
          <h2 id="author-title" className="font-serif text-[34px] sm:text-5xl font-bold text-white" data-id="element-75" data-mp="nijy4bddbpjx">I'm Dr. Michael Carter</h2>
          <p data-id="element-76" data-mp="sgldal7ob4q4">
            I created Otoplasty Clinical Pathway System™ because I wanted to address a problem in professional education: information can be
            valuable while still being difficult to organize into a consistent learning process.
          </p>
          <p data-id="element-77" data-mp="1v7ews1k0f56o">
            One resource explains an anatomical concept. Another discusses a procedural consideration. A third presents an educational case.
            And eventually, you're left trying to connect everything yourself.
          </p>
          <p data-id="element-78" data-mp="1la0t72j6qavs">
            I don't believe the answer is always another enormous course or another collection of disconnected notes. Sometimes, a structured
            educational framework can make it easier to organize what you're studying, identify the questions you still have, and document
            what you learn.
          </p>
          <p className="font-semibold text-white" data-id="element-79" data-mp="17g157xtondmr">That's the idea behind this system. I organized the material around:</p>
          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-80" data-mp="xjy6l1y1hx4k">
            {authorPillars.map(p => <li key={p} className="flex gap-2.5 text-white" data-id="element-81" data-mp="nvj29apiikjs">
                <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-82" data-mp="ny57v4suepzd" />
                <span data-id="element-83" data-mp="st2g49iasvb7">{p}</span>
              </li>)}
          </ul>
          <p data-id="element-84" data-mp="dzfr5fconbkp">
            My intention is to provide a practical educational resource that qualified professionals can use alongside appropriate training,
            current literature, mentorship, and clinical guidance.
          </p>
          <p className="text-white/60 text-[15px]" data-id="element-85" data-mp="16owisashaofv">
            This system is not a universal surgical protocol and does not replace individualized assessment or professional judgment.
          </p>
          <p data-id="element-86" data-mp="wuwbq3dmz94i">I hope it helps you approach your study of otoplasty with a clearer and more organized process.</p>
          <p className="font-serif text-xl font-bold italic text-white" data-id="element-87" data-mp="1plo8b1ym5zsd">— Dr. Michael Carter</p>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-5xl" data-id="element-88" data-mp="1uceak6bqtmiu">
        <CtaButton label="I want to learn with Dr. Carter's system" data-id="element-89" data-mp="1ue7ma017qwxp" />
      </div>
    </section>;
}